import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  ProjectSettingControllerService,
  ProjectSettingResponse,
  ProjectSettingUpsertRequest,
} from '@frontend/shared-api';

@Injectable({
  providedIn: 'root',
})
export class Step13ProjectSettingsService {
  private readonly projectSettingService = inject(ProjectSettingControllerService);

  getProjectSettings(projectId: number): Observable<ProjectSettingResponse> {
    return this.projectSettingService.getProjectSetting({
      projectId: projectId,
    });
  }

  upsertProjectSettings(
    projectId: number,
    settings: ProjectSettingUpsertRequest,
  ): Observable<ProjectSettingResponse> {
    return this.projectSettingService.upsertProjectSetting({
      projectId: projectId,
      projectSettingUpsertRequest: settings,
    });
  }
}
